import { Component, OnInit } from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { ContribuicoesMeusPlanosPage } from "./contribuicoes-meus-planos/contribuicoes-meus-planos.page";
import { ContribuicoesParcelasPage } from "./contribuicoes-parcelas/contribuicoes-parcelas.page";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-contribuicoes-minhas",
  templateUrl: "./contribuicoes-minhas.page.html",
  styleUrls: ["./contribuicoes-minhas.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule],
})
export class ContribuicoesMinhasPage implements OnInit {

  constructor(public modalCtrl: ModalController) {}

  ngOnInit() {}

  async openMeus() {
    const modalPage = await this.modalCtrl.create({
      component: ContribuicoesMeusPlanosPage,
    });
    modalPage.present();
  }

  async openParcelas() {
    const modalPage = await this.modalCtrl.create({
      component: ContribuicoesParcelasPage,
    });
    modalPage.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
